// import React, {useState, useEffect, useRef } from 'react'
// import './about.css';
// import { Blog, Brand, Info, CTA } from '../../@/components';
// import play from '../../main_assets/play.png';
// import { Team } from '../../containers';
// import link from '../../main_assets/link.PNG';
// import about1 from '../../main_assets/about1.jpg';
// import about2 from '../../main_assets/about2.jpg';
// import about3 from '../../main_assets/about3.jpg';
// import Slider from 'react-slick'; 
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
// import BlurhashImg from '../../@/components/Image/BlurhashImg';

// const testimonialData = [
//   {
//     content: "Whether it is body products, food, fashion, entertainment, or the technology industry, our passion is to make your brand and products stand out.",
//     name: "Name, title"
//   },
//   {
//     content: "The team delivered exceptional creative work that perfectly captured our brand vision. Their attention to detail and innovative approach helped us stand out in a crowded market. We've seen remarkable engagement since launching the new design.",
//     name: "Name, title"
//   },
//   {
//     content: "Working with this agency transformed our visual identity. They understood our needs from day one and created designs that truly resonate with our audience. Their collaborative process made the entire experience seamless and enjoyable.",
//     name: "Name, title"
//   }
// ];

// const NextArrow = (props) => {
//   const { className, onClick } = props;
//   return (
//     <div className="testimonial-arrow next-arrow" onClick={onClick}>
//       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//       </svg>
//     </div>
//   );
// };

// const PrevArrow = (props) => {
//   const { className, onClick } = props;
//   return (
//     <div className="testimonial-arrow prev-arrow" onClick={onClick}>
//       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//       </svg>
//     </div>
//   );
// };

// // Updated slider settings
// const sliderSettings = {
//   dots: false,
//   infinite: true,
//   speed: 500,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   initialSlide: 0,
//   variableWidth: false, 
//   centerMode: false, 
//   centerPadding: '0',
//   nextArrow: <NextArrow />,
//   prevArrow: <PrevArrow />,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         infinite: true,
//         dots: false,
//         centerMode: false,
//         variableWidth: false
//       }
//     },
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         variableWidth: false,
//         centerMode: false,
//         centerPadding: '0',
//         infinite: true,
//       }
//     }
//   ]
// };

// const About = () => {
//   const [playing, setPlaying] = useState([false, false, false]);
//   const videoRefs = [useRef(null), useRef(null), useRef(null)]; 
//   const [isModalOpen, setModalOpen] = useState(false);

//   const openModal = () => setModalOpen(true);
//   const closeModal = () => setModalOpen(false);

//   const handleShareButtonClick = () => {
//     openModal();
//   };

//   const handleModalClose = () => {
//     closeModal();
//     document.body.classList.remove('popup-open');
//   };

//   const handleModalOpen = () => {
//     openModal();
//     document.body.classList.add('popup-open');
//   };

//   useEffect(() => {
//     const handleBodyScroll = () => {
//       if (isModalOpen) {
//         document.body.style.overflow = 'hidden';
//       } else {
//         document.body.style.overflow = 'auto';
//       }
//     };

//     handleBodyScroll(); 
//     window.addEventListener('scroll', handleBodyScroll);
//     return () => {
//       window.removeEventListener('scroll', handleBodyScroll); 
//     };
//   }, [isModalOpen]);

//   const handlePlayPause = (index) => {
//     return () => {
//       if (videoRefs[index].current) {
//         const updatedPlaying = [...playing];
//         updatedPlaying[index] = !playing[index];
//         setPlaying(updatedPlaying);

//         const video = videoRefs[index].current;

//         if (!playing[index] || video.ended) {
//           video.play();
//         } else {
//           video.pause();
//         }
//       }
//     };
//   };

//   const handleVideoEnded = (index) => () => {
//     const updatedPlaying = [...playing];
//     updatedPlaying[index] = false;
//     setPlaying(updatedPlaying);
//   };
//   return (
//     <div className="about-page" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      
//       <div div className="about">
//         {/* <Blog /> */}
//         <div className="gpt__blog section__padding">
//           <div className="gpt__blog-feature-1">
//             <h4>We believe in the quiet power of extraordinary design</h4>
//           </div>
//         </div>  
//         <div className="single-image-sec section__padding">
//           <BlurhashImg src="https://i.postimg.cc/dvmrvdpR/Website-Image-1.avif" placeholderColor="#888"/>
//         </div>
//         <div className="gpt__blog section__padding">
//           <div className="">
//             <div className="gpt__whatgpt-heading">
//               <h1 className="explore__text">Our Story</h1>
//             </div>
//             <div className="gpt__blog-container">
//               <h4>Ulevus was created out of the desire to move design away from templated and copied work. We began with a simple belief: design should connect, not just decorate. With the goal of bringing pride to African designers and creatives, we push to raise the bar and design great products in the heart of Cameroon and across Africa</h4>
//               <h4>We are on a mission to create a high-valued coalition of experts with a variety of skills in the design industry—one where strategy and soul work hand in hand.</h4>
//             </div>
//           </div>
//         </div>

//         <hr className='white-divider' />

//         {/* <Brand /> */}
//         <div className="gpt__brand section__padding">
//           <div className="gpt__brand_container-process">
//             <div className="brand-process">
//               <h1 className="explore__text">FOUNDED IN</h1>
//               <h4>Excellence as a baseline, distinction as a demand, and minimalism as clarity—we exist to quiet the noise and build brave brands that last.</h4>
//             </div>
//           </div>
//         </div>
//         <hr className='white-divider' />

//         <div className="gpt__blog section__padding">
//           <div className="">
//             <div className="gpt__whatgpt-heading_2">
//               <h1 className="explore__text">Our Values</h1>
//             </div>
//             <div className="gpt__blog-container_2">
//               <h4>We are never the best—but we are truly good, because there is always room for better. At Ulevus, yesterday’s best is today’s good. We work tirelessly to innovate our design processes and offerings, delivering excellent products and services to our clients and their customers. </h4>
//               <h4>For every project, big or small, we apply Design Thinking and Human-Centered Design principles. That’s why we treat our clients’ work with utmost seriousness: they need to connect authentically with the people who engage with their values and brand.</h4>
//             </div>
//           </div>
//         </div>

//         <hr className='white-divider' />

//         <div className="single-image-section-about section__padding">
//           <BlurhashImg src={about1} placeholderColor="#888"/>
//           <BlurhashImg src={about2} placeholderColor="#888"/>
//           <BlurhashImg src={about3} placeholderColor="#888"/>
//         </div>
        
//         <div className="gpt__blog gpt__blog_about">
//           <div className="gpt__blog-feature">
//             <h4>Exceptional work is always intentional. We draw on well-informed insights to build brands and experiences that stir emotions and create lasting impact.</h4>
//           </div>
//         </div>

//         <div className="gpt__blog section__padding">
//           <div className="">
//             <div className="gpt__whatgpt-heading_2">
//               <h1 className="explore__text">Our Creative Process</h1>
//             </div>
//             <div className="gpt__blog-container_2">
//               <h4>We don’t just design—we solve. We start by listening to you and your clients' pain points. Then we step away from the computer and into the streets, gaining firsthand experience of the problems you are solving through market research, data gathering, and immersive observation. </h4>
//               <h4>Finally, we innovate using today's technology and design thinking processes to produce results that make your brand stand out and become loved.</h4>
//             </div>
//           </div>
//         </div>

//         <hr className='white-divider' />
//         {/* <div className="testimonials-container">
//           <h1 className="testimonials-title"></h1>
          
//           <div className="testimonials-content">
//             <div className="testimonials-slider-container">
//               <Slider {...sliderSettings}>
//                 {testimonialData.map((testimonial, index) => (
//                   <div key={index} className="testimonial-slide">
//                     <p className="testimonial-text"><span className="testimonials-title">Testimonials</span> <br/><br/><span className="testimonial-cont">{testimonial.content}</span> <br/><br/> <span className="testimonial-author">{testimonial.name}</span> </p>
//                     <p className="testimonial-author"></p>
//                   </div>
//                 ))}
//               </Slider>
//             </div>
//           </div>
//         </div> */}
//         <Team />
//         <div className="ulev__footer-icotext section__padding">
//           <button style={{ display: 'flex', alignItems: 'center', marginRight: 'auto', background: 'none', border: 'none' }}>
//             <p className='reach' style={{ marginRight: '10px', color: "#888" }}>Connect with us</p>
//           </button>

//           <button className='cont' onClick={openModal} style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginTop: '25px', cursor: 'pointer', background: 'none', border: 'none' }}>
//             <span style={{ display: 'flex', justifyContent: 'center', paddingBottom: '5px' }}>
//               <img src={link} alt="linked" />
//             </span>
//           </button>
//         </div>
//       </div>
//     </div>
//   )
// }
 
// export default About








import React, { useState, useEffect, useRef } from 'react';
import './about.css';
import { Blog, Brand, Info, CTA } from '../../@/components';
import play from '../../main_assets/play.png';
import { Team } from '../../containers';
import link from '../../main_assets/link.PNG';
import about1 from '../../main_assets/about1.jpg';
import about2 from '../../main_assets/about2.jpg';
import about3 from '../../main_assets/about3.jpg';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import BlurhashImg from '../../@/components/Image/BlurhashImg';
import emailjs from '@emailjs/browser';

const testimonialData = [
  {
    content: "Whether it is body products, food, fashion, entertainment, or the technology industry, our passion is to make your brand and products stand out.",
    name: "Name, title"
  },
  {
    content: "The team delivered exceptional creative work that perfectly captured our brand vision. Their attention to detail and innovative approach helped us stand out in a crowded market. We've seen remarkable engagement since launching the new design.",
    name: "Name, title"
  },
  {
    content: "Working with this agency transformed our visual identity. They understood our needs from day one and created designs that truly resonate with our audience. Their collaborative process made the entire experience seamless and enjoyable.",
    name: "Name, title"
  }
];

const NextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className="testimonial-arrow next-arrow" onClick={onClick}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  );
};

const PrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className="testimonial-arrow prev-arrow" onClick={onClick}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  );
};

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  variableWidth: false,
  centerMode: false,
  centerPadding: '0',
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        centerMode: false,
        variableWidth: false
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: false,
        centerMode: false,
        centerPadding: '0',
        infinite: true,
      }
    }
  ]
};

const About = () => {
  const [playing, setPlaying] = useState([false, false, false]);
  const videoRefs = [useRef(null), useRef(null), useRef(null)];
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [emailStatus, setEmailStatus] = useState('');
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
    time: new Date().toLocaleString()
  });

  useEffect(() => {
    emailjs.init("ISG04P_c0uObH1Og8");
    
    const handleBodyScroll = () => {
      if (showEmailForm) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    };

    handleBodyScroll();
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showEmailForm]);

  const handlePlayPause = (index) => {
    return () => {
      if (videoRefs[index].current) {
        const updatedPlaying = [...playing];
        updatedPlaying[index] = !playing[index];
        setPlaying(updatedPlaying);

        const video = videoRefs[index].current;

        if (!playing[index] || video.ended) {
          video.play();
        } else {
          video.pause();
        }
      }
    };
  };

  const handleVideoEnded = (index) => () => {
    const updatedPlaying = [...playing];
    updatedPlaying[index] = false;
    setPlaying(updatedPlaying);
  };

  const toggleEmailForm = () => {
    setShowEmailForm(prev => !prev);
    setEmailStatus('');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
      time: new Date().toLocaleString()
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setEmailStatus('sending');
    
    const templateParams = {
      name: formData.name,
      email: formData.email,
      company: formData.company,
      message: formData.message,
      time: formData.time,
      from_name: formData.name,
      to_email: "marcel.ulevus@gmail.com",
      reply_to: formData.email,
      to_name: "Ulevus Team",
      subject: `New contact from ${formData.name}${formData.company ? ` at ${formData.company}` : ''}`
    };
    
    const serviceId = 'service_yf0fnk1';
    const templateId = 'template_azclhrj';
    
    emailjs.send(serviceId, templateId, templateParams)
      .then((result) => {
        console.log('Email sent successfully:', result.text);
        setEmailStatus('success');
        setFormData({
          name: '',
          email: '',
          company: '',
          message: '',
          time: new Date().toLocaleString()
        });
        setTimeout(() => {
          setEmailStatus('');
        }, 3000);
      })
      .catch((error) => {
        console.error('Email send failed:', error);
        if (error.text) {
          console.error('Error details:', error.text);
        }
        if (error.status) {
          console.error('Error status:', error.status);
        }
        setEmailStatus('error');
      });
  };

  return (
    <div className="about-page">
      <div className="about">
        <div className="gpt__blog section__padding">
          <div className="gpt__blog-feature-1">
            <h4>We believe in the quiet power of extraordinary design</h4>
          </div>
        </div>
        
        <div className="single-image-sec section__padding">
          <BlurhashImg src="https://i.postimg.cc/dvmrvdpR/Website-Image-1.avif" placeholderColor="#888"/>
        </div>
        
        <div className="gpt__blog section__padding">
          <div className="">
            <div className="gpt__whatgpt-heading">
              <h1 className="explore__text">Our Story</h1>
            </div>
            <div className="gpt__blog-container">
              <h4>Ulevus was created out of the desire to move design away from templated and copied work. We began with a simple belief: design should connect, not just decorate. With the goal of bringing pride to African designers and creatives, we push to raise the bar and design great products in the heart of Cameroon and across Africa.</h4>
              <h4>We are on a mission to create a high-valued coalition of experts with a variety of skills in the design industry—one where strategy and soul work hand in hand.</h4>
            </div>
          </div>
        </div>

        <hr className='white-divider' />

        <div className="gpt__brand section__padding">
          <div className="gpt__brand_container-process">
            <div className="brand-process">
              <h1 className="explore__text">FOUNDED IN</h1>
              <h4>Excellence as a baseline, distinction as a demand, and minimalism as clarity—we exist to quiet the noise and build brave brands that last.</h4>
            </div>
          </div>
        </div>
        
        <hr className='white-divider' />

        <div className="gpt__blog section__padding">
          <div className="">
            <div className="gpt__whatgpt-heading_2">
              <h1 className="explore__text">Our Values</h1>
            </div>
            <div className="gpt__blog-container_2">
              <h4>We are never the best—but we are truly good, because there is always room for better. At Ulevus, yesterday's best is today's good. We work tirelessly to innovate our design processes and offerings, delivering excellent products and services to our clients and their customers. </h4>
              <h4>For every project, big or small, we apply Design Thinking and Human-Centered Design principles. That's why we treat our clients' work with utmost seriousness: they need to connect authentically with the people who engage with their values and brand.</h4>
            </div>
          </div>
        </div>

        <hr className='white-divider' />

        <div className="single-image-section-about section__padding">
          <BlurhashImg src={about1} placeholderColor="#888"/>
          <BlurhashImg src={about2} placeholderColor="#888"/>
          <BlurhashImg src={about3} placeholderColor="#888"/>
        </div>
        
        <div className="gpt__blog gpt__blog_about">
          <div className="gpt__blog-feature">
            <h4>Exceptional work is always intentional. We draw on well-informed insights to build brands and experiences that stir emotions and create lasting impact.</h4>
          </div>
        </div>

        <div className="gpt__blog section__padding">
          <div className="">
            <div className="gpt__whatgpt-heading_2">
              <h1 className="explore__text">Our Creative Process</h1>
            </div>
            <div className="gpt__blog-container_2">
              <h4>We don't just design—we solve. We start by listening to you and your clients' pain points. Then we step away from the computer and into the streets, gaining firsthand experience of the problems you are solving through market research, data gathering, and immersive observation. </h4>
              <h4>Finally, we innovate using today's technology and design thinking processes to produce results that make your brand stand out and become loved.</h4>
            </div>
          </div>
        </div>

        <hr className='white-divider' />
        
        <Team />
        
        <div className="ulev__footer-icotext section__padding">
          <button 
            onClick={toggleEmailForm}
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              marginRight: 'auto', 
              background: 'none', 
              border: 'none',
              cursor: 'pointer'
            }}
          >
            <p className='reach' style={{ marginRight: '10px', color: "#888" }}>Connect with us</p>
          </button>

          <button 
            className='cont' 
            onClick={toggleEmailForm} 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              marginLeft: 'auto', 
              marginTop: '25px', 
              cursor: 'pointer', 
              background: 'none', 
              border: 'none' 
            }}
          >
            <span style={{ display: 'flex', justifyContent: 'center', paddingBottom: '5px' }}>
              <img src={link} alt="linked" />
            </span>
          </button>
        </div>
      </div>

      {showEmailForm && (
        <div className="email-modal-overlay" onClick={toggleEmailForm}>
          <div className="email-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Send us a message</h3>
              <button 
                className="close-button"
                onClick={toggleEmailForm}
                type="button"
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            
            {emailStatus === 'success' ? (
              <div className="email-success">
                <p>Your message has been sent successfully!</p>
              </div>
            ) : (
              <form ref={formRef} onSubmit={handleSubmit} className="dark-form">
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="styled-input"
                    placeholder="Your name"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="styled-input"
                    placeholder="Your email address"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="company">Company</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                    className="styled-input"
                    placeholder="Your company"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Tell us about your project</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows="6"
                    className="styled-textarea"
                    placeholder="Describe your project or inquiry"
                  />
                </div>
                
                <button 
                  type="submit" 
                  className="submit-button minimal-submit"
                  disabled={emailStatus === 'sending'}
                >
                  {emailStatus === 'sending' ? 'Sending...' : 'Send Message'}
                </button>
                
                {emailStatus === 'error' && (
                  <p className="error-message">
                    Failed to send message. Please try again or contact us directly at info@ulevus.com
                  </p>
                )}
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default About;